import React, { useState, useEffect } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import ValidView from '../../components/app/validView';
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion, Spinner as SpinnerB } from 'react-bootstrap';
import Spinner from '../utils/Spinner';
import InputText from '../../components/Forms/InputText'

const TabClientIdentyti = ({ setCloseButton, t1dataShopId, conditionView, handleClose, providerTypeOptions }) => {
    const [data, setData] = useState(null);
    const { allowWrite, allowView, userToken } = ValidView("Clients");
    const [enableSaveChanges, setEnableSaveChanges] = useState(true);
    const [successSend, setSuccessend] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [viewSpinner, setViewSpinner] = useState(true);

    const [serviceStatus, setServiceStatus] = useState('inactive');
    const [serviceSignatureType, setServiceSignatureType] = useState('');
    const [dataService, setDataService] = useState({
        api: '',
        url: '',
        code: '',
        name: '',
        version: '',
        providerType: ''
    });

    const formFieldsHandler = (event) => {
        switch (event.target.name) {
            case 'Api': setDataService({ ...dataService, api: event.target.value }); break;
            case 'Url': setDataService({ ...dataService, url: event.target.value }); break;
            case 'Code': setDataService({ ...dataService, code: event.target.value !== "" ? parseInt(event.target.value) : 0 }); break;
            case 'NameId': setDataService({ ...dataService, name: event.target.value }); break;
            case 'Version': setDataService({ ...dataService, version: event.target.value !== "" ? parseInt(event.target.value) : 0 }); break;
            case 'ProviderType': setDataService({ ...dataService, providerType: event.target.value }); break;
            case 'Status': setServiceStatus(event.target.value); break;
            default: break;
        }
        setEnableSaveChanges(false);
    }

    useEffect(() => {
        if (userToken)
            fetchData();

    }, [userToken]);

    const fetchData = async () => {

        let requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userToken
            }
        };

        try {
            const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + `/clients/identity/store/${t1dataShopId}`, requestOptions);
            const json = await response.json();
            if (json.data && json.data.length > 0) {
                setData(json.data[0]);

                if (json.data[0].services) {
                    const paginasService = json.data[0].services.find(service => service.service === "paginas");
                    if (paginasService) {
                        setDataService({
                            api: paginasService.data?.api || "",
                            url: paginasService.data?.url || "",
                            code: paginasService.data?.code || "",
                            name: paginasService.data?.name || "",
                            version: paginasService.data?.version || "",
                            providerType: paginasService.data?.providerType || ""
                        });
                        setServiceStatus(paginasService.status);
                        setServiceSignatureType(paginasService.signatureType);
                    }
                }
            }
            setViewSpinner(false);
        } catch (error) {
            console.log(error);
        }
    };

    function sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time)
        )
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        let dataServiceUpdate = { service: 'paginas', status: serviceStatus, signatureType: serviceSignatureType, data: dataService };
        let requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userToken
            },
            body: JSON.stringify(dataServiceUpdate)
        };

        try {
            const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + `/clients/identity/store/${t1dataShopId}`, requestOptions);
            const json = await response.json();

            if (json.data.status === 'success') {

                setSuccessend('success');
                sleep(1500).then(() => {
                    setIsLoading(false);
                    handleClose();
                    window.location.href = '/Clients';
                })
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
            setSuccessend('danger');
        }
    };

    const renderInputs = (data) => {

        return (<>
            {isLoading ? <Spinner /> : null}

            <Row className="mb-3">
                <InputText defaultValue={data.api} label={'Api'} handler={formFieldsHandler} conditionView={conditionView} width={'4'} />
                <InputText defaultValue={data.url} label={'Url'} handler={formFieldsHandler} conditionView={conditionView} width={'4'} />
                <InputText defaultValue={data.code} label={'Code'} handler={formFieldsHandler} conditionView={conditionView} width={'4'} />
            </Row>

            <Row className="mb-3">
                <InputText defaultValue={data.name} label={'NameId'} handler={formFieldsHandler} conditionView={conditionView} width={'4'} />
                <InputText defaultValue={data.version} label={'Version'} handler={formFieldsHandler} conditionView={conditionView} width={'4'} />

                <Form.Group as={Col} md="4" controlId="validProviderType">
                    <Form.Label>ProviderType</Form.Label>
                    <Form.Select
                        name="ProviderType"
                        onChange={conditionView ? null : formFieldsHandler}
                        readOnly={conditionView ? true : false}
                        disabled={conditionView ? true : false}
                        value={data.providerType}
                    >

                        {providerTypeOptions.map((itemRole) => {
                            return (<option key={itemRole} value={itemRole}>{itemRole}</option>)
                        })}
                        
                    </Form.Select>
                </Form.Group>
            </Row>

            <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="validCustom16">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                        required="Plan Type is required"
                        name="Status"
                        onChange={conditionView ? null : formFieldsHandler}
                        readOnly={conditionView ? true : false}
                        disabled={conditionView ? true : false}
                        value={serviceStatus}
                    >
                        <option key='inactive' value='inactive' >Inactive</option>
                        <option key='active' value='active' >Active</option>
                    </Form.Select>
                </Form.Group>
            </Row>
        </>)
    };

    let addSubmitButton = "";
    if (!conditionView) {
        addSubmitButton = (<><Button type="button" disabled={enableSaveChanges} onClick={() => handleSubmit()} >Save</Button></>);
    }

    return (
        <div>

            <Accordion defaultActiveKey="1">

                <Accordion.Item eventKey="0">
                    <Accordion.Header> JSON </Accordion.Header>
                    <Accordion.Body>
                        <pre style={{ maxHeight: '50vh', overflowY: 'auto', marginBottom: '20px' }}>
                            {JSON.stringify(data, null, 2)}
                        </pre>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Edit Service Identyti</Accordion.Header>
                    <Accordion.Body>
                        {data && (
                            <>
                                {renderInputs(dataService)}
                            </>
                        )}

                        {viewSpinner && (
                            <SpinnerB animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </SpinnerB>
                        )}
                    </Accordion.Body>
                </Accordion.Item>

            </Accordion>
            <br />
            {addSubmitButton}
            {'  '}  {'  '}
            {setCloseButton}
            <br />
            {(successSend == 'danger') ? (<Alert key='danger' variant='danger'> ¡Not Update!</Alert>)
                : (successSend == 'success') ? (<Alert key='success' variant='success'> ¡Send POST Success!</Alert>) : ""}
        </div>
    );
};

export default TabClientIdentyti;